// extracted by mini-css-extract-plugin
export default {"eruditTeachersGrid":"PrepodsList_eruditTeachersGrid__0Cg4j"};